import html2canvas from 'html2canvas';

//html2canvas 图片下载
export default (dom)=>{
  html2canvas(dom).then(function(canvas) {
    let a = document.createElement('a');
    a.setAttribute('download',`${new Date().getTime()}下载图片`);
    a.setAttribute('href',canvas.toDataURL())
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  });
}
